// pages/ResetPasswordPage.jsx

import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Logo from "../shared/components/Logo";

const RESET_URL = `${process.env.REACT_APP_API_BASE_URL}/password/reset`;

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Get data from URL
  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError("");

    // VALIDATION
    if (!password || !confirmPassword) {
      return setError("Please enter both password fields.");
    }

    if (password.length < 4) {
      return setError("Password must be at least 4 characters.");
    }

    if (password !== confirmPassword) {
      return setError("Passwords do not match.");
    }

    setLoading(true);

    try {
      const response = await fetch(RESET_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
          email,
          password,
          password_confirmation: confirmPassword,
        }),
      });

      const data = await response.json();

      // API ERROR
      if (!response.ok || data.code !== 200) {
        setError(data.message || "Reset failed. Please try again.");
        return;
      }

      // SUCCESS
      setError("Password reset successful! Redirecting to login...");

      setTimeout(() => {
        navigate("/login");
      }, 2000);

    } catch (err) {
      setError("Network error. Please check your connection.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <Logo />

        <div className="login-heading">Reset Password</div>
        <div className="login-subtext">
          Enter your new password to continue
        </div>

        {/* error box */}
        {error && <div className="error-box">{error}</div>}

        {/* EMAIL */}
        <label className="form-label">Email</label>
        <input
          className="form-input"
          type="email"
          value={email || ""}
          disabled
        />

        {/* PASSWORD */}
        <label className="form-label">Password</label>
        <input
          className="form-input"
          type="password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
        />

        {/* CONFIRM PASSWORD */}
        <label className="form-label">Confirm Password</label>
        <input
          className="form-input"
          type="password"
          placeholder="••••••••"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
        />

        <button
          className="btn-primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Resetting..." : "Reset Password →"}
        </button>
      </div>
    </div>
  );
};

export default ResetPasswordPage;